// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"styles_sectionWrapper__6NweP","contactData":"styles_contactData__6PDsQ"};